import React from "react";
import styled from "styled-components";

const ResponsiveLayout = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    margin-right: -30px;    
`;

export const ResponsiveLayoutItem = styled.div`
    padding-bottom: 12px;
    padding-right: 12px;
    
    flex-grow: 0;
    flex-shrink: 0;

    flex-basis: 19%;

    @media only screen and (max-width: 2480px) {
      flex-basis: 24%;
    }
    
    @media only screen and (max-width: 1664px) {
      flex-basis: 32%;
    }
    
    @media only screen and (max-width: 1232px) {
      flex-basis: 48%;
    }
    
    @media only screen and (max-width: 750px) {
      flex-basis: 100%;
    }
`;

export default ResponsiveLayout;